import { render, staticRenderFns } from "./FormProtocol.vue?vue&type=template&id=07fb960b"
import script from "./FormProtocol.vue?vue&type=script&lang=js"
export * from "./FormProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports